module.exports = __webpack_public_path__ + "c23036eda9b5b64918f55cce108024f4.gif";